var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "certificate-page" },
    [
      _c(
        "van-pull-refresh",
        {
          attrs: { "success-text": "刷新成功" },
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing"
          }
        },
        [
          _c("div", { staticClass: "page-header" }, [
            _c("div", { staticClass: "header-content" }, [
              _c("h1", { staticClass: "page-title" }, [_vm._v("🏆 证书收集")]),
              _vm._v(" "),
              _c("p", { staticClass: "page-subtitle" }, [
                _vm._v(
                  "已收集 " +
                    _vm._s(_vm.earnedCount) +
                    " / " +
                    _vm._s(_vm.allCertificates.length) +
                    " 个证书"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "how-to-get" }, [
            _c(
              "div",
              {
                staticClass: "how-to-header",
                on: {
                  click: function($event) {
                    _vm.showHowTo = !_vm.showHowTo
                  }
                }
              },
              [
                _c("span", { staticClass: "how-to-icon" }, [_vm._v("💡")]),
                _vm._v(" "),
                _c("span", { staticClass: "how-to-title" }, [
                  _vm._v("如何获取证书？")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "how-to-arrow",
                    class: { expanded: _vm.showHowTo }
                  },
                  [_vm._v("›")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showHowTo,
                    expression: "showHowTo"
                  }
                ],
                staticClass: "how-to-content"
              },
              [
                _c("div", { staticClass: "how-to-item" }, [
                  _c("span", { staticClass: "step-num" }, [_vm._v("1")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-info" }, [
                    _c("p", { staticClass: "step-title" }, [
                      _vm._v("完成课程学习")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "step-desc" }, [
                      _vm._v("观看完整课程视频或学习资料")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "how-to-item" }, [
                  _c("span", { staticClass: "step-num" }, [_vm._v("2")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-info" }, [
                    _c("p", { staticClass: "step-title" }, [
                      _vm._v("通过课程考试")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "step-desc" }, [
                      _vm._v("完成相关考试并达到合格分数")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "how-to-item" }, [
                  _c("span", { staticClass: "step-num" }, [_vm._v("3")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-info" }, [
                    _c("p", { staticClass: "step-title" }, [
                      _vm._v("自动发放证书")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "step-desc" }, [
                      _vm._v("满足条件后系统自动颁发证书")
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "certificate-container" }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "certificate-skeleton-grid" },
                  _vm._l(4, function(i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "cert-skeleton-card" },
                      [
                        _c("div", { staticClass: "skeleton-preview" }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "skeleton-line skeleton-name"
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "skeleton-line skeleton-status-line"
                        })
                      ]
                    )
                  }),
                  0
                )
              : _vm.allCertificates.length > 0
              ? _c(
                  "div",
                  { staticClass: "certificate-grid" },
                  _vm._l(_vm.allCertificates, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "cert-card",
                        class: {
                          "cert-earned": item.IsEarned,
                          "cert-locked": !item.IsEarned
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCertClick(item)
                          }
                        }
                      },
                      [
                        item.PreviewImage
                          ? _c("div", { staticClass: "cert-preview" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImageUrl(item.PreviewImage),
                                  alt: item.Name
                                }
                              }),
                              _vm._v(" "),
                              !item.IsEarned
                                ? _c(
                                    "div",
                                    { staticClass: "preview-overlay" },
                                    [
                                      _c("span", { staticClass: "lock-icon" }, [
                                        _vm._v("🔒")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _c("div", { staticClass: "cert-icon-wrapper" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cert-icon",
                                  class: { "icon-earned": item.IsEarned }
                                },
                                [
                                  item.IsEarned
                                    ? _c("span", [_vm._v("🏅")])
                                    : _c("span", [_vm._v("🔒")])
                                ]
                              ),
                              _vm._v(" "),
                              item.IsEarned
                                ? _c("div", { staticClass: "cert-shine" })
                                : _vm._e()
                            ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "cert-name" }, [
                          _vm._v(_vm._s(item.Name))
                        ]),
                        _vm._v(" "),
                        item.IsEarned
                          ? _c("p", { staticClass: "cert-status" }, [
                              _c("span", { staticClass: "status-earned" }, [
                                _vm._v("✓ 已获得")
                              ])
                            ])
                          : item.RuleType === 2 && item.ApplyStatus === 0
                          ? _c(
                              "p",
                              {
                                staticClass: "cert-status",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showRuleDialog(item)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "status-pending" }, [
                                  _vm._v("⏳ 审核中")
                                ])
                              ]
                            )
                          : item.RuleType === 2 && item.ApplyStatus === 2
                          ? _c(
                              "p",
                              {
                                staticClass: "cert-status",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showRuleDialog(item)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "status-rejected" }, [
                                  _vm._v("❌ 已驳回")
                                ])
                              ]
                            )
                          : _c(
                              "p",
                              {
                                staticClass: "cert-condition",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showRuleDialog(item)
                                  }
                                }
                              },
                              [
                                item.AcquireType === "exam"
                                  ? _c(
                                      "span",
                                      { staticClass: "acquire-type-hint" },
                                      [_vm._v("📝 考试获得")]
                                    )
                                  : item.RuleType === 2
                                  ? _c(
                                      "span",
                                      { staticClass: "acquire-type-hint" },
                                      [_vm._v("📝 申请审核")]
                                    )
                                  : item.ConditionProgressList &&
                                    item.ConditionProgressList.length > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "acquire-type-hint" },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.getOverallProgress(item)
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "view-detail" }, [
                                  _vm._v("查看领取条件 ›")
                                ])
                              ]
                            ),
                        _vm._v(" "),
                        !item.IsEarned && item.RuleType === 2 && item.CanApply
                          ? _c(
                              "div",
                              {
                                staticClass: "cert-apply-wrap",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.openApplyDialog(item)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "cert-apply-btn" }, [
                                  item.ApplyStatus === 2
                                    ? _c("span", [_vm._v("🔄 重新申请")])
                                    : _c("span", [_vm._v("📝 立即申请")])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.IsEarned && item.CreateTime
                          ? _c("p", { staticClass: "cert-time" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.formatDate(item.CreateTime)) +
                                  "\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.IsEarned && item.DeliveryStatus > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "cert-delivery-wrap",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.goDelivery(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "cert-delivery-btn",
                                    class: {
                                      "btn-pending": item.DeliveryStatus === 1,
                                      "btn-shipping":
                                        item.DeliveryStatus === 2 ||
                                        item.DeliveryStatus === 3,
                                      "btn-received": item.DeliveryStatus === 4
                                    }
                                  },
                                  [
                                    item.DeliveryStatus === 1
                                      ? _c("span", [_vm._v("📮 填写邮寄地址")])
                                      : item.DeliveryStatus === 2
                                      ? _c("span", [_vm._v("📦 待发货")])
                                      : item.DeliveryStatus === 3
                                      ? _c("span", [_vm._v("🚚 查看物流")])
                                      : item.DeliveryStatus === 4
                                      ? _c("span", [_vm._v("✅ 已签收")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading && _vm.allCertificates.length === 0
              ? _c("div", { staticClass: "empty-state" }, [
                  _c("div", { staticClass: "empty-icon" }, [_vm._v("🎯")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-title" }, [_vm._v("暂无证书")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-desc" }, [
                    _vm._v("完成课程学习和考试后即可获得证书")
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "van-dialog",
            {
              staticClass: "cert-rule-dialog",
              attrs: {
                title: "证书获取条件",
                "show-confirm-button": false,
                "close-on-click-overlay": true,
                "get-container": "body",
                "lock-scroll": true
              },
              model: {
                value: _vm.showRulePopup,
                callback: function($$v) {
                  _vm.showRulePopup = $$v
                },
                expression: "showRulePopup"
              }
            },
            [
              _vm.selectedCert
                ? _c("div", { staticClass: "rule-dialog-content" }, [
                    _c("div", { staticClass: "rule-lock-icon" }, [
                      _vm._v("🔐")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "rule-cert-name" }, [
                      _vm._v(_vm._s(_vm.selectedCert.Name))
                    ]),
                    _vm._v(" "),
                    _vm.selectedCert.ConditionLogic
                      ? _c("div", { staticClass: "rule-logic-tag" }, [
                          _vm.selectedCert.ConditionLogic === "AND"
                            ? _c("span", [_vm._v("需满足全部条件")])
                            : _c("span", [_vm._v("满足任一条件即可")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCert.ConditionProgressList &&
                    _vm.selectedCert.ConditionProgressList.length > 0
                      ? _c("div", { staticClass: "rule-precourse-list" }, [
                          _c("p", { staticClass: "rule-precourse-title" }, [
                            _vm._v("📋 完成情况：")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "rule-precourse-items" },
                            [
                              _vm._l(
                                _vm.selectedCert.ConditionProgressList,
                                function(prog, idx) {
                                  return [
                                    prog.TargetType === "course"
                                      ? _c(
                                          "div",
                                          {
                                            key: "prog-" + idx,
                                            staticClass: "rule-precourse-item",
                                            class: {
                                              completed: prog.IsSatisfied
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goToCourse(prog)
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "rule-status-dot",
                                              class: prog.IsSatisfied
                                                ? "dot-green"
                                                : "dot-red"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-name"
                                              },
                                              [_vm._v(_vm._s(prog.Description))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-action"
                                              },
                                              [
                                                prog.IsSatisfied
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-done"
                                                      },
                                                      [_vm._v("✓ 已完成")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass: "action-go"
                                                      },
                                                      [_vm._v("去学习 ›")]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      : prog.TargetType === "exam"
                                      ? _c(
                                          "div",
                                          {
                                            key: "prog-" + idx,
                                            staticClass: "rule-precourse-item",
                                            class: {
                                              completed: prog.IsSatisfied
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goToExam(prog)
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "rule-status-dot",
                                              class: prog.IsSatisfied
                                                ? "dot-green"
                                                : "dot-red"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-name"
                                              },
                                              [_vm._v(_vm._s(prog.Description))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-action"
                                              },
                                              [
                                                prog.IsSatisfied
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-done"
                                                      },
                                                      [_vm._v("✓ 已通过")]
                                                    )
                                                  : prog.PreCourseCompleted ===
                                                    false
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-warn"
                                                      },
                                                      [_vm._v("需先完成课程")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass: "action-go"
                                                      },
                                                      [_vm._v("去考试 ›")]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      : prog.TargetType === "hours" ||
                                        prog.TargetType === "count"
                                      ? _c(
                                          "div",
                                          {
                                            key: "prog-" + idx,
                                            staticClass:
                                              "rule-precourse-item rule-progress-item-bar"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rule-progress-header"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "rule-status-dot",
                                                  class: prog.IsSatisfied
                                                    ? "dot-green"
                                                    : "dot-red"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "rule-precourse-name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(prog.Description)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rule-progress-bar-wrap"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "rule-progress-bar-bg"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "rule-progress-bar-fill",
                                                      class: {
                                                        "bar-done":
                                                          prog.IsSatisfied
                                                      },
                                                      style: {
                                                        width:
                                                          prog.ProgressPercent +
                                                          "%"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "rule-progress-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(prog.ProgressText)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : prog.TargetType === "certificate"
                                      ? _c(
                                          "div",
                                          {
                                            key: "prog-" + idx,
                                            staticClass: "rule-precourse-item",
                                            class: {
                                              completed: prog.IsSatisfied
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "rule-status-dot",
                                              class: prog.IsSatisfied
                                                ? "dot-green"
                                                : "dot-red"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-name"
                                              },
                                              [_vm._v(_vm._s(prog.Description))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-action"
                                              },
                                              [
                                                prog.IsSatisfied
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-done"
                                                      },
                                                      [_vm._v("✓ 已获得")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-pending"
                                                      },
                                                      [_vm._v("未获得")]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            key: "prog-" + idx,
                                            staticClass: "rule-precourse-item"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "rule-status-dot",
                                              class: prog.IsSatisfied
                                                ? "dot-green"
                                                : "dot-red"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-name"
                                              },
                                              [_vm._v(_vm._s(prog.Description))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rule-precourse-action"
                                              },
                                              [
                                                prog.IsSatisfied
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-done"
                                                      },
                                                      [_vm._v("✓")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "action-pending"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            prog.ProgressText
                                                          )
                                                        )
                                                      ]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          )
                        ])
                      : _vm.selectedCert.RuleConditionDescs &&
                        _vm.selectedCert.RuleConditionDescs.length > 0
                      ? _c("div", { staticClass: "rule-precourse-list" }, [
                          _c("p", { staticClass: "rule-precourse-title" }, [
                            _vm._v("📋 获取条件：")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "rule-precourse-items" },
                            _vm._l(
                              _vm.selectedCert.RuleConditionDescs,
                              function(desc, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: idx,
                                    staticClass: "rule-precourse-item"
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "rule-status-dot dot-red"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "rule-precourse-name" },
                                      [_vm._v(_vm._s(desc))]
                                    )
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasExamWithUnfinishedCourse
                      ? _c("div", { staticClass: "rule-exam-tip" }, [
                          _c("span", { staticClass: "tip-icon" }, [
                            _vm._v("💡")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tip-text" }, [
                            _vm._v("考试需先完成关联课程学习后才能参加")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCert.RuleType === 2 &&
                    _vm.selectedCert.ApplyStatus === 0
                      ? _c("div", { staticClass: "rule-apply-tip" }, [
                          _c("span", { staticClass: "tip-icon" }, [
                            _vm._v("⏳")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tip-text" }, [
                            _vm._v("申请已提交，请耐心等待管理员审核")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCert.RuleType === 2 &&
                    _vm.selectedCert.ApplyStatus === 2
                      ? _c(
                          "div",
                          {
                            staticClass: "rule-apply-tip rule-apply-tip-error"
                          },
                          [
                            _c("span", { staticClass: "tip-icon" }, [
                              _vm._v("❌")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "tip-text" }, [
                              _vm._v("\n          上次申请被驳回"),
                              _vm.selectedCert.ApplyAuditRemark
                                ? _c("span", [
                                    _vm._v(
                                      "：" +
                                        _vm._s(
                                          _vm.selectedCert.ApplyAuditRemark
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCert.RuleType === 2
                      ? _c("p", { staticClass: "rule-hint" }, [
                          _vm._v(
                            "\n        满足条件后可主动申请，由管理员审核通过后发放\n      "
                          )
                        ])
                      : _c("p", { staticClass: "rule-hint" }, [
                          _vm._v("完成上述条件后，证书将自动发放")
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rule-dialog-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-close",
                          on: {
                            click: function($event) {
                              _vm.showRulePopup = false
                            }
                          }
                        },
                        [_vm._v("我知道了")]
                      )
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "van-dialog",
            {
              staticClass: "cert-apply-dialog",
              attrs: {
                title: "提交证书申请",
                "show-confirm-button": false,
                "close-on-click-overlay": !_vm.applySubmitting,
                "get-container": "body",
                "lock-scroll": true
              },
              model: {
                value: _vm.showApplyPopup,
                callback: function($$v) {
                  _vm.showApplyPopup = $$v
                },
                expression: "showApplyPopup"
              }
            },
            [
              _vm.applyTarget
                ? _c("div", { staticClass: "apply-dialog-content" }, [
                    _c("p", { staticClass: "apply-cert-name" }, [
                      _vm._v(_vm._s(_vm.applyTarget.Name))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "apply-tip" }, [
                      _vm._v("确认提交后由管理员审核，可在本页面查看进度")
                    ]),
                    _vm._v(" "),
                    !_vm.showRemarkInput
                      ? _c(
                          "div",
                          {
                            staticClass: "apply-remark-toggle",
                            on: {
                              click: function($event) {
                                _vm.showRemarkInput = true
                              }
                            }
                          },
                          [_c("span", [_vm._v("➕ 补充备注（选填）")])]
                        )
                      : _c("div", { staticClass: "apply-remark-block" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.applyRemark,
                                expression: "applyRemark"
                              }
                            ],
                            staticClass: "apply-remark-input",
                            attrs: {
                              placeholder: "例如补充说明、联系方式等",
                              maxlength: "500",
                              rows: "3"
                            },
                            domProps: { value: _vm.applyRemark },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.applyRemark = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "apply-remark-counter" }, [
                            _vm._v(_vm._s(_vm.applyRemark.length) + " / 500")
                          ])
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "apply-dialog-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-cancel",
                          attrs: { disabled: _vm.applySubmitting },
                          on: {
                            click: function($event) {
                              _vm.showApplyPopup = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-submit",
                          attrs: { disabled: _vm.applySubmitting },
                          on: { click: _vm.submitApply }
                        },
                        [
                          _vm.applySubmitting
                            ? _c("span", [_vm._v("提交中...")])
                            : _c("span", [_vm._v("确认提交")])
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "feedbackFab",
          staticClass: "feedback-fab",
          class: { "feedback-fab-attract": _vm.fabAttract },
          on: {
            click: _vm.openFeedbackDialog,
            animationend: function($event) {
              _vm.fabAttract = false
            }
          }
        },
        [
          _c("span", { staticClass: "feedback-fab-icon" }, [_vm._v("💬")]),
          _vm._v(" "),
          _c("span", { staticClass: "feedback-fab-text" }, [_vm._v("意见反馈")])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          staticClass: "feedback-dialog",
          attrs: {
            title: "意见反馈",
            "show-confirm-button": false,
            "close-on-click-overlay": !_vm.feedbackSubmitting,
            "get-container": "body",
            "lock-scroll": true
          },
          model: {
            value: _vm.showFeedbackPopup,
            callback: function($$v) {
              _vm.showFeedbackPopup = $$v
            },
            expression: "showFeedbackPopup"
          }
        },
        [
          _c("div", { staticClass: "feedback-dialog-content" }, [
            _c("p", { staticClass: "feedback-tip" }, [
              _vm._v("您的每一条建议我们都认真对待")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feedback-textarea-wrap" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.feedbackContent,
                    expression: "feedbackContent"
                  }
                ],
                staticClass: "feedback-textarea",
                attrs: {
                  placeholder: "请输入您的意见或建议...",
                  maxlength: "500",
                  rows: "5"
                },
                domProps: { value: _vm.feedbackContent },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.feedbackContent = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "feedback-counter" }, [
                _vm._v(_vm._s(_vm.feedbackContent.length) + " / 500")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "feedback-checkbox-wrap",
                on: {
                  click: function($event) {
                    _vm.feedbackAllowContact = !_vm.feedbackAllowContact
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "feedback-checkbox",
                    class: { checked: _vm.feedbackAllowContact }
                  },
                  [
                    _vm.feedbackAllowContact
                      ? _c("span", { staticClass: "check-mark" }, [_vm._v("✓")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "feedback-checkbox-label" }, [
                  _vm._v("允许开发者主动联系我")
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "feedback-dialog-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn-cancel",
                  attrs: { disabled: _vm.feedbackSubmitting },
                  on: {
                    click: function($event) {
                      _vm.showFeedbackPopup = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-submit",
                  attrs: {
                    disabled: !_vm.canSubmitFeedback || _vm.feedbackSubmitting
                  },
                  on: { click: _vm.submitFeedback }
                },
                [
                  _vm.feedbackSubmitting
                    ? _c("span", [_vm._v("提交中...")])
                    : _c("span", [_vm._v("提交反馈")])
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035ad140", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035ad140","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/certificate_list.vue
// module id = null
// module chunks = 